export default __webpack_public_path__ + "static/media/health_check_male_3x2_Hk.dc7e4825.webp";